import { color, EL_COLORS } from '@/colors';
import { FlexCol, FlexCenVer } from '@/UI/styles';
import { EllipsisText } from '@/UI/EllipsisText/EllipsisText';
import { NodeTextField } from '@/UI/NodeTextField/NodeTextField';
import type { TextAsset } from '@/types/api/assets';

interface TextViewerProps {
  file: TextAsset;
  index: number;
  onTextChange?: (index: number, value: string) => void;
  hasMultipleFiles?: boolean;
  isMultiFilesViewMode: boolean;
  fixedItemSize?: number;
}

export function TextViewer({
  file,
  index,
  onTextChange,
  hasMultipleFiles,
  isMultiFilesViewMode,
  fixedItemSize,
}: TextViewerProps) {
  return (
    <FlexCol
      sx={{
        bgcolor: color.Black84,
        width: '100%',
        position: 'relative',
        flex: 1,
        minHeight: 0,
      }}
      className="nodrag node-text-viewer"
    >
      {isMultiFilesViewMode ? (
        <FlexCenVer
          sx={{
            bgcolor: color.Black84,
            width: '100%',
            height: `${fixedItemSize!}px`,
            px: 3,
            borderRadius: 2,
            border: `1px solid ${EL_COLORS.BoxBorder}`,
            justifyContent: 'flex-start',
          }}
        >
          <EllipsisText
            variant="body-std-rg"
            isMultiLine
            delay={500}
            enterNextDelay={800}
            linesNumber={fixedItemSize! > 200 ? 8 : 4}
            sx={{
              color: color.White64_T,
              width: '100%',
              fontSize: '16px',
              wordBreak: 'break-word',
            }}
          >
            {'value' in file ? file.value : ''}
          </EllipsisText>
        </FlexCenVer>
      ) : (
        <NodeTextField
          value={'value' in file ? file.value : ''}
          multiline
          fullWidth
          size="small"
          onChange={(e) => {
            if (onTextChange) {
              onTextChange(index, e.target.value);
            }
          }}
          readOnly={!onTextChange}
          rootSx={{
            transition: 'padding 0.1s ease-in-out',
            p: 3,
            pt: hasMultipleFiles ? 5 : 3,
            pb: 4,
            ...(!onTextChange && { cursor: 'inherit', '& textarea': { cursor: 'inherit' } }),
          }}
        />
      )}
    </FlexCol>
  );
}
